<template>
  <div class="vip-detail-seckill-orders">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="vipDetailSeckillOrdersInfos.orders" border style="width: 100%" v-loading="loading">
        <el-table-column prop="orderId" :label="$t('vipDetailSeckillOrders.orderId')" align="center"
          width="180"></el-table-column>
        <el-table-column label="商品图片" align="center" width="120">
          <template #default="{ row }">
            <el-image style="width: 50px; height: 50px; border-radius: 10px;"
              :src="row.coverPhoto || '/img/noPhoto.jpg'" :preview-src-list="[row.coverPhoto]" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="prodName" :label="$t('vipDetailSeckillOrders.productName')" align="center"
          ></el-table-column>
        <el-table-column prop="buyerName" :label="$t('vipDetailSeckillOrders.buyer')" align="center"
         ></el-table-column>
        <el-table-column prop="goodsNum" :label="$t('vipDetailSeckillOrders.purchaseQuantity')" align="center"
          width="120"></el-table-column>
        <el-table-column prop="killPrice" :label="$t('vipDetailSeckillOrders.seckillPrice')" align="center"
          ></el-table-column>
        <el-table-column prop="createTime" :label="$t('vipDetailSeckillOrders.purchaseTime')" align="center"
          width="160"></el-table-column>
        <el-table-column :label="$t('vipDetailSeckillOrders.status')" align="center" width="120">
          <template #default="{ row }">
            {{ row.state === 'C' ? $t('vipDetailSeckillOrders.completed') : $t('vipDetailSeckillOrders.pendingPayment')
            }}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('vipDetailSeckillOrders.deadline')" align="center"
          width="160"></el-table-column>
      </el-table>

      <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { listProductSeckillOrder } from '@/api/user/vipDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailSeckillOrders',
  data() {
    return {
      vipDetailSeckillOrdersInfos: {
        orders: [],
        link: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  methods: {
    open(data) {
      this.vipDetailSeckillOrdersInfos.link = data.tel
      this.loadSeckillOrdersData()
    },
    loadSeckillOrdersData() {
      if (!this.vipDetailSeckillOrdersInfos.link) return

      this.loading = true
      const params = {
        link: this.vipDetailSeckillOrdersInfos.link,
        shopId: this.shopId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      listProductSeckillOrder(params)
        .then(res => {
          this.vipDetailSeckillOrdersInfos.orders = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取秒杀订单数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadSeckillOrdersData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadSeckillOrdersData()
    }
  }
}
</script>

<style scoped>
.vip-detail-seckill-orders {
  padding: 20px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>